<template>
  <el-breadcrumb separator="•">
    <!-- <el-breadcrumb-item>{{ $t("organizations.groups") }}</el-breadcrumb-item> -->
    <el-breadcrumb-item>{{ organizationData.name }}</el-breadcrumb-item>
    <el-breadcrumb-item v-for="(item, index) in items" :key="index">{{ item }}</el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
export default {
  props: {
    items: {
      type: Array
    },
  },
  computed: {
    organizationData() {
      return this.$store.state.organization.currentOrganization;
    },
  },
}
</script>

<style lang="scss" scoped>
  @import '../../scss/colors';
.el-breadcrumb {
  height: 60px;
  line-height: 60px;
  background: #f9f9f9;
  padding-left: 40px;
}

::v-deep .el-breadcrumb__inner {
  font-size: 18px;
  line-height: 28px;
  color: #121131;
}

::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner {
  font-weight: 500;
  color: #007eff;
}

::v-deep .blue-color .el-breadcrumb__inner {
  color: $hyperlink;
}
</style>
